import script from "./VueMigrationLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueMigrationLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__